"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportTypes = exports.ReportKinds = void 0;
exports.ReportKinds = ['platform', 'project', 'task', 'worker', 'miscellaneous', 'graphs'];
exports.ReportTypes = ['static', 'dynamic'];
//# sourceMappingURL=Reports.js.map